import { render, staticRenderFns } from "./CreditsContainer.vue?vue&type=template&id=e3f6f9e2&scoped=true&"
import script from "./CreditsContainer.vue?vue&type=script&lang=js&"
export * from "./CreditsContainer.vue?vue&type=script&lang=js&"
import style0 from "./CreditsContainer.vue?vue&type=style&index=0&id=e3f6f9e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f6f9e2",
  null
  
)

export default component.exports